import { ctw } from '@/common';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms';

type QuestionMarkTooltipProps = {
  text: string;
  className?: string;
};

export const QuestionMarkTooltip: React.FC<QuestionMarkTooltipProps> = ({ text, className }) => (
  <TooltipProvider delayDuration={0}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={ctw(
            'flex h-4 w-4 cursor-help items-center justify-center rounded-full bg-zinc-100 text-xs font-medium text-stone-300',
            className,
          )}
        >
          ?
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        <p className="text-sm">{text}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
